import { defineComponent, computed, ref, onBeforeUnmount } from "vue";
import DeviceSelect from "./DeviceSelect.vue.mjs";
import { useRoomStore } from "../../stores/room.mjs";
import { SettingMode } from "../../constants/render.mjs";
import { useI18n } from "../../locales/index.mjs";
import { storeToRefs } from "pinia";
import { useBasicStore } from "../../stores/basic.mjs";
import { isElectron } from "../../utils/environment.mjs";
import useGetRoomEngine from "../../hooks/useRoomEngine.mjs";
import TuiButton from "./base/Button.vue.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AudioSettingTab",
  props: {
    mode: null,
    audioVolume: null,
    theme: null
  },
  setup(__props) {
    var _a;
    const props = __props;
    const settingMode = props.mode || SettingMode.SIMPLE;
    const isSampleMode = computed(() => settingMode === SettingMode.SIMPLE);
    const isDetailMode = computed(() => settingMode === SettingMode.DETAIL);
    const basicStore = useBasicStore();
    const { userId } = storeToRefs(basicStore);
    const roomStore = useRoomStore();
    const { speakerList, userVolumeObj, currentSpeakerId } = storeToRefs(roomStore);
    const roomEngine = useGetRoomEngine();
    const trtcCloud = (_a = roomEngine.instance) == null ? void 0 : _a.getTRTCCloud();
    const themeClass = computed(
      () => props.theme ? `tui-theme-${props.theme}` : ""
    );
    const volumeTotalNum = computed(() => isDetailMode.value ? 36 : 28);
    const volumeNum = computed(() => {
      const volume = props.audioVolume || userVolumeObj.value[userId.value] || 0;
      return volume * volumeTotalNum.value / 100;
    });
    const showVolume = computed(
      () => isSampleMode.value || isDetailMode.value && isTestingMicrophone.value
    );
    const isTestingMicrophone = ref(false);
    function handleMicrophoneTest() {
      isTestingMicrophone.value = !isTestingMicrophone.value;
    }
    const isTestingSpeaker = ref(false);
    const audioPlayer = document == null ? void 0 : document.createElement("audio");
    if (audioPlayer && typeof audioPlayer.loop !== "undefined") {
      audioPlayer.loop = true;
    }
    const { t } = useI18n();
    async function handleSpeakerTest() {
      const SPEAKER_TEST_URL = "https://web.sdk.qcloud.com/trtc/electron/download/resources/media/TestSpeaker.mp3";
      isTestingSpeaker.value = !isTestingSpeaker.value;
      const isStartSpeakerTest = isTestingSpeaker.value;
      if (isElectron) {
        if (isStartSpeakerTest) {
          trtcCloud == null ? void 0 : trtcCloud.startSpeakerDeviceTest(SPEAKER_TEST_URL);
        } else {
          trtcCloud == null ? void 0 : trtcCloud.stopSpeakerDeviceTest();
        }
        return;
      }
      if (!audioPlayer) {
        return;
      }
      if (isStartSpeakerTest) {
        await (audioPlayer == null ? void 0 : audioPlayer.setSinkId(currentSpeakerId.value));
        audioPlayer.src = SPEAKER_TEST_URL;
        audioPlayer.play();
      } else {
        audioPlayer.pause();
        audioPlayer.currentTime = 0;
      }
    }
    onBeforeUnmount(() => {
      if (isElectron) {
        trtcCloud == null ? void 0 : trtcCloud.stopSpeakerDeviceTest();
        return;
      }
      audioPlayer && audioPlayer.pause();
    });
    return { __sfc: true, props, settingMode, isSampleMode, isDetailMode, basicStore, userId, roomStore, speakerList, userVolumeObj, currentSpeakerId, roomEngine, trtcCloud, themeClass, volumeTotalNum, volumeNum, showVolume, isTestingMicrophone, handleMicrophoneTest, isTestingSpeaker, audioPlayer, t, handleSpeakerTest, DeviceSelect, SettingMode, TuiButton };
  }
});
export {
  _sfc_main as default
};
